import { useEffect, useRef, useState } from "react";

/**
 * Custom hook to calculate drawer height based on remaining viewport space
 * after accounting for a header element
 */
export function useCalculatedDrawerHeight() {
  const headerRef = useRef<HTMLDivElement>(null);
  const drawerRef = useRef<HTMLDivElement>(null);
  const [drawerHeight, setDrawerHeight] = useState<string>("100vh");

  useEffect(() => {
    const calculateDrawerHeight = () => {
      if (headerRef.current) {
        const headerHeight = headerRef.current.offsetHeight;
        const viewportHeight = window.innerHeight;
        const remainingHeight = viewportHeight - headerHeight;
        const newHeight = `${remainingHeight}px`;
        setDrawerHeight(newHeight);

        // Set CSS custom property on the drawer element
        if (drawerRef.current) {
          drawerRef.current.style.setProperty("--drawer-max-height", newHeight);
        }
      }
    };

    // Calculate initial height
    calculateDrawerHeight();

    // Recalculate on window resize
    window.addEventListener("resize", calculateDrawerHeight);

    return () => {
      window.removeEventListener("resize", calculateDrawerHeight);
    };
  }, []);

  return {
    headerRef,
    drawerRef,
    drawerHeight,
  };
}
